import Loader from "atoms/loaders/loader";
import { UserBookmarkCountBy } from "models/enumerations/sorting/user-bookmarks/user-bookmark-count-by";
import React from "react";
import useFilterBookmarks from "utilities/hooks/domain/my-link/use-filter-bookmarks";
import useSearchBookmarks from "utilities/hooks/domain/my-link/use-search-bookmarks";
import useBookmarkGroups from "utilities/hooks/queries/my-link/bookmarks/grouped/use-bookmark-groups-query";
import EmptyMyLinkPanel from "../empty-mylink-panel";
import MyBookmarksAccordionPanel from "./my-bookmarks-accordion-panel";
import MyBookmarksGroupedByLayout from "./my-bookmarks-groups-by-layout";
import FilterByShareStatus from "./options/filter-by-share-status";
import SearchBookmarks from "./options/search-bookmarks";
import ColorAccordionPanelHeader from "./accordions/color-accordion-panel-header";
import BookmarkCountSortBy from "./options/bookmark-count-sort-by";
import useSortBookmarkCounts from "utilities/hooks/domain/my-link/use-sort-bookmark-counts";
import UserBookmarkShareFilterOption from "models/enumerations/filtering/user-bookmarks/user-bookmark-share-filter-option";

const MyBookmarksViewByColor = () => {
    const { onSortByChange, sortBy } = useSortBookmarkCounts(
        UserBookmarkCountBy.Color
    );
    const { onSearchTextChange, searchText } = useSearchBookmarks(
        UserBookmarkCountBy.Color
    );
    const { onShareFilterChange, shareFilter } = useFilterBookmarks(
        UserBookmarkCountBy.Color
    );
    const { bookmarkGroups, isLoadingCounts } = useBookmarkGroups(
        UserBookmarkCountBy.Color,
        {
            searchText: searchText,
            sortOption: sortBy,
            bookmarksCreatedByMe:
                shareFilter === UserBookmarkShareFilterOption.PrivateOnly,
        }
    );

    return (
        <MyBookmarksGroupedByLayout
            countBy={UserBookmarkCountBy.Color}
            dropdowns={
                <>
                    <FilterByShareStatus
                        onChange={onShareFilterChange}
                        shareStatus={shareFilter}
                    />
                    <BookmarkCountSortBy
                        onChange={onSortByChange}
                        sort={sortBy}
                    />
                    <SearchBookmarks
                        searchText={searchText}
                        onChange={onSearchTextChange}
                    />
                </>
            }>
            {isLoadingCounts ? (
                <Loader />
            ) : (
                <>
                    {bookmarkGroups?.length ? (
                        bookmarkGroups?.map((group) => (
                            <MyBookmarksAccordionPanel
                                key={group.id}
                                id={group.id}
                                groupBy={UserBookmarkCountBy.Color}
                                filterBookmarksBySearch={true}
                                header={
                                    <ColorAccordionPanelHeader
                                        title={group.name}
                                        color={Number(group.id)}
                                        numberOfBookmarks={group.count}
                                    />
                                }
                            />
                        ))
                    ) : (
                        <EmptyMyLinkPanel />
                    )}
                </>
            )}
        </MyBookmarksGroupedByLayout>
    );
};

export default MyBookmarksViewByColor;
